<form [formGroup]="form" (submit)="submitChanges(form.value)">
    <mat-card-content class="ph125" flex layout="column">
        <div
            class="description"
            translate="settings.report_email_settings.description"
        ></div>

        <mat-form-field class="full-width" floatPlaceholder="always">
            <input
                matInput
                placeholder="{{
                    'settings.report_email_settings.fields.subject' | translate
                }}"
                formControlName="reportEmailSubject"
            />
        </mat-form-field>

        <mat-form-field class="full-width" floatPlaceholder="always">
            <textarea
                matInput
                placeholder="{{
                    'settings.report_email_settings.fields.content' | translate
                }}"
                formControlName="reportEmailContent"
            ></textarea>
        </mat-form-field>
    </mat-card-content>

    <mat-card-actions align="end" class="mh125 mv125">
        <button
            mat-raised-button
            color="primary"
            type="submit"
            [disabled]="!form.valid"
            class="uppercase"
        >
            {{ "save" | translate }}
        </button>
    </mat-card-actions>
</form>



// WEBPACK FOOTER //
// /app/src/app/settings/components/report-email-settings/report-email-settings.component.html